import { init } from '@dash0/sdk-web';
import { metrics } from '@opentelemetry/api';
import { MeterProvider, PeriodicExportingMetricReader } from '@opentelemetry/sdk-metrics';
import { OTLPMetricExporter } from '@opentelemetry/exporter-metrics-otlp-http';
import { resourceFromAttributes } from '@opentelemetry/resources';

const endpoint = import.meta.env.PUBLIC_DASH0_ENDPOINT as string | undefined;
const authToken = import.meta.env.PUBLIC_DASH0_AUTH_TOKEN as string | undefined;
const serviceName = (import.meta.env.PUBLIC_DASH0_SERVICE_NAME as string | undefined) ?? 'storebuilder';
const serviceVersion = import.meta.env.PUBLIC_DASH0_SERVICE_VERSION as string | undefined;
const environment = import.meta.env.PUBLIC_DASH0_ENV as string | undefined;

if (endpoint && authToken) {
  init({
    serviceName,
    endpoint: { url: endpoint, authToken, dataset: environment },
  });

  const resourceAttributes: Record<string, string> = { 'service.name': serviceName };
  if (serviceVersion) resourceAttributes['service.version'] = serviceVersion;
  if (environment) resourceAttributes['deployment.environment.name'] = environment;

  const meterProvider = new MeterProvider({
    resource: resourceFromAttributes(resourceAttributes),
    readers: [
      new PeriodicExportingMetricReader({
        exporter: new OTLPMetricExporter({
          url: `${endpoint}/v1/metrics`,
          headers: { Authorization: `Bearer ${authToken}` },
        }),
        exportIntervalMillis: 30_000,
      }),
    ],
  });

  metrics.setGlobalMeterProvider(meterProvider);
}

export function getMeter(name: string) {
  return metrics.getMeter(name);
}
